var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgT5ThingsConcept = function SvgT5ThingsConcept(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.6 21.2a2 2 0 0 0-3.2-2.4l-4.616 6.155-.37-.37a2 2 0 0 0-2.828 2.83l2 2A2 2 0 0 0 77.6 29.2l6-8zM70 18a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-2a2 2 0 1 0-4 0v2H70V22h4a2 2 0 1 0 0-4h-4zm-58 5a2 2 0 0 1 2-2h38a2 2 0 1 1 0 4H14a2 2 0 0 1-2-2zm0 8a2 2 0 0 1 2-2h20a2 2 0 1 1 0 4H14a2 2 0 0 1-2-2zm2 11a2 2 0 1 0 0 4h38a2 2 0 1 0 0-4H14zm-2 10a2 2 0 0 1 2-2h32a2 2 0 1 1 0 4H14a2 2 0 0 1-2-2zm2 11a2 2 0 1 0 0 4h38a2 2 0 1 0 0-4H14zm-2 10a2 2 0 0 1 2-2h26a2 2 0 1 1 0 4H14a2 2 0 0 1-2-2zm54-30a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H70a4 4 0 0 1-4-4V43zm14 0H70v10h10V43zM70 60a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V64a4 4 0 0 0-4-4H70zm0 4h10v10H70V64z"
  })));
};

export default SvgT5ThingsConcept;